import { render, staticRenderFns } from "./OrganisationAdd.vue?vue&type=template&id=0b5231e7&"
import script from "./OrganisationAdd.vue?vue&type=script&lang=ts&"
export * from "./OrganisationAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5231e7')) {
      api.createRecord('0b5231e7', component.options)
    } else {
      api.reload('0b5231e7', component.options)
    }
    module.hot.accept("./OrganisationAdd.vue?vue&type=template&id=0b5231e7&", function () {
      api.rerender('0b5231e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationAdd.vue"
export default component.exports